import { Check, Copy } from 'lucide-react'
import { useState } from 'react'
import { getGroupInviteUrl } from '../lib/groupInvite'
import { Button } from './ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog'
import { Input } from './ui/input'

// Copy-the-link fallback for screens without a share sheet (desktop), and for
// when the share sheet fails.
export default function GroupInviteDialog({ open, onOpenChange, groupId, groupName }) {
  const [copied, setCopied] = useState(false)
  const inviteUrl = getGroupInviteUrl(groupId)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Clipboard blocked: the link stays selectable in the input.
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Invite people</DialogTitle>
          <DialogDescription>
            Send this link to anyone you want in {groupName}.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <label className="text-sm font-medium mb-2 block" htmlFor="group-invite-link">Invite link</label>
            <div className="flex gap-2">
              <Input
                id="group-invite-link"
                value={inviteUrl}
                readOnly
                onFocus={(e) => e.target.select()}
                className="text-sm"
              />
              <Button variant="outline" size="icon" onClick={handleCopy} aria-label="Copy invite link">
                {copied ? <Check className="h-4 w-4 text-success" /> : <Copy className="h-4 w-4" />}
              </Button>
            </div>
            <p className="text-xs text-muted-foreground mt-2">
              Anyone with this link can see the group and join right away. New players sign up
              first and land in the group automatically.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
